import React, { PureComponent, Fragment } from 'react';
import { I18n } from 'aws-amplify';
import styled from 'styled-components';
import { Link, Redirect } from "react-router-dom";

import { formatMoney2, formatMoneyInput, formatMoneyGraph } from '../../../utils/helpers'
import {
    Table,
    Popconfirm,
    Tooltip,
    Tag,
    Icon
} from 'antd';

import { ProjectTypeNames, ProjectExtraTypeNames } from '../../../model';

import FormatCurrency from '../../../components/ui/format-currency';


const Btns = styled.p`
width: 100px;
display: block;
    a {
        margin-left: 10px;
    }
`

const FooterT = styled.div`
    font-weight: bold;
    text-align: right;
`

class tableExtras extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
    }

    getSector = (sectorId) => {
        const items = this.props.sectorsFlat && this.props.sectorsFlat.filter((item) => item.code == sectorId);


        if (items && items.length) {
            return items[0].label;
        }
        else {
            return {};
        }

    }

    getStatus(value) {
        if (!this.props.bp || !this.props.bp.clientProjectStatusesMap) return '';

        return this.props.bp.clientProjectStatusesMap[value] && this.props.bp.clientProjectStatusesMap[value].label;
    }


    render() {
        const columns = [
            {
                title: I18n.get("País"),
                dataIndex: 'country',
                key: 'country',
                width: 70,
                render: (country) => {
                    if (country) {
                        return <img src={`https://assets-ollo.bpool.co/country-flags/png24px/${country}.png`} />
                    } else {
                        return "";
                    }
                }

            },

            {
                title: I18n.get("SKU"),
                dataIndex: 'sku',
                key: 'sku',
                // render: (expertise) => this.getSector(expertise),
            },
            {
                title: I18n.get("Nome projeto"),
                dataIndex: 'nameProject',
                width: 150,
                key: 'nameProject',
                // render: (name, record) => <Link to={`/bpool/projetos/${record.item.projectId}`}>{name || `S/N (${record.item.name} - ${record.item.email})`}</Link>,
            },
            {
                title: I18n.get("Cliente"),
                dataIndex: 'client',
                key: 'client',
            },
            {
                title: I18n.get("Parceiro"),
                dataIndex: 'partner',
                key: 'partner',
                // render: (price,record) => <FormatCurrency amount={price} symbol={record.item.currency.symbolOnly} tSeparator={record.item.currency.thousandSeparator} dSeparator={record.item.currency.decimalSeparator} />,
            },
            {
                title: I18n.get("Nome Extra"),
                dataIndex: 'name',
                width: 150,
                key: 'name',
                render: (name, record) => <Link to={`/bpool/projetos/${record.item.projectId}`}>{name || `S/N (${record.item.name} - ${record.item.email})`}</Link>,
            },
            {
                title: I18n.get("Tipo"),
                dataIndex: 'type',
                key: 'type',
                width: 180,
                render: (type) => <Tag>{type}</Tag>,
            },
            {
                title: I18n.get("Status"),
                dataIndex: 'status',
                key: 'status',
            },
            {
                title: I18n.get("Budget"),
                dataIndex: 'price',
                key: 'price',
                width: 120,
                render: (price, record) => {
                    return (

                        <Fragment>
                            <Tooltip title={record?.item?.currency?.name}>
                                {record?.item?.currency?.symbolOnly}
                            </Tooltip>  {" "}
                            <FormatCurrency amount={price} currency={record?.item?.currency} />
                        </Fragment>
                    )
                }
            },
            {
                title: I18n.get("Data"),
                dataIndex: 'date',
                width: 110,
                key: 'date',
            },
            {
                title: '',
                dataIndex: 'actions',
                key: 'item',
                width: 100,
                render: (text, record) => {
                    let data = {
                        extraId: record.item.extraId,
                        projectId: record.item.projectId,
                    }

                    if (!this.props.isView) {
                        return (
                            <Btns>
                                <Popconfirm
                                    title={I18n.get("Deseja cancelar esse projeto?")}
                                    icon={<Icon type="question-circle-o" style={{ color: 'red' }} />}
                                    onConfirm={() => this.props.cancel(data)}
                                    okText={I18n.get("Sim")}
                                    cancelText={I18n.get("Não")}
                                >

                                    <a>
                                        <Tooltip title={I18n.get("Cancelar extra")}>
                                            <Icon type="stop" theme="filled" />
                                        </Tooltip>
                                    </a>
                                </Popconfirm>
                                <Popconfirm
                                    title={I18n.get("Deseja deletar esse projeto?")}
                                    icon={<Icon type="question-circle-o" style={{ color: 'red' }} />}
                                    onConfirm={() => this.props.delete(data)}
                                    okText={I18n.get("Sim")}
                                    cancelText={I18n.get("Não")}
                                >
                                    <a>
                                        <Tooltip title={I18n.get("Deletar extra")}>
                                            <Icon type="delete" theme="filled" />
                                        </Tooltip>
                                    </a>
                                </Popconfirm>

                            </Btns>
                        )
                    }

                }
            },
        ]

        let dataTable = this.props.data && this.props.data.map((item, index) => {
            return {
                key: index,
                numero: index,
                country: item.clientCountry && item.clientCountry.isO2 && item.clientCountry.isO2.toLowerCase(),
                type: ProjectExtraTypeNames[item.extraType],
                sku: item.projectSKU,
                nameProject: item.projectName,
                name: item.extraName,
                client: item.clientName,
                status: this.getStatus(item.status),
                price: item.budget,
                partner: item.partnerName,
                date: item.createdOn,
                item: item
            }
        });


        return (
            <Table
                pagination={this.props.pagination ? true : false}
                columns={columns}
                dataSource={dataTable}
                locale={{ emptyText: I18n.get('Sem informação') }}
                scroll={{ x: 1200 }}
            />
        );
    }
}

export default tableExtras;
